/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Metric_Total_Tps_Name_RangeInputs */



/**
* | output |
* | --- |
* | "Total TPS ({range})" |
*
* @param {Metric_Total_Tps_Name_RangeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_total_tps_name_range = /** @type {((inputs: Metric_Total_Tps_Name_RangeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Total_Tps_Name_RangeInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Total TPS (${i?.range})`)
});